export enum PaymentSyncStatus {
    InProgress = 'InProgress',
    Completed = 'Completed',
    Error = 'Error',
}

export enum PaymentSyncType {
    Invoice = 'Invoice',
    Bill = 'Bill'
}